import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import ActionBar from "../../common/ActionBar";
import { PageWrapper } from "./styles";
import CaseDetailsCard from "../../common/Casecard";
import _ from "lodash";
import { navigate } from "@reach/router";
import CaseService from "../../../services/CaseService";
import useLoader from "../../../hooks/useLoader";
import {
  RESPONDANT_ONBOARDED,
  CLAIMENT_STR,
  NEGOTIATION_REACHED,
  BOTH_PAID_NEGOTIATION,
} from "../../../helpers/constants";
import useLifecycleStages from "../../../hooks/useLifecycleStages";
import { getErrorMessage } from "../../../helpers/functions";
import { useSnackbar } from "notistack";
import NegotiationState from "./NegotiationState";
import DrawerTable from "../../internal/DrawerTable";
import PaymentModal from "./common/PaymentModal";
import AssignCaseMediator from "./common/AssignCaseMediatorModal";
import MediationState from "./MediationState";
import CaseCTA from "./common/CaseCTA";
import theme from "../../../assets/theme";
import AlertDialog from "../../common/Alert";
import queryString from "query-string";
import useNotification from "../../../hooks/useNotification";
import CopytoClipboard from "./common/CopytoClipboard.js";
import TranscriptionSettings from "../../internal/TranscriptionSettingsCases";
import COLORS from "../../../assets/Colors";
import styled from "styled-components";
import CaseDetailsStatus from "../../internal/CaseDetailsStatus";
import ExtraFieldsDrawer from "../../internal/DrawerTable/ExtraFieldsDrawer.js";
import RTMP from "./common/RTMP.js";
import GenerateGlobalMeeting from "../../internal/GlobalMeeting/index.js";

/* ─── Constants ──────────────────────────────────────────────────────────── */

const PARTY_PARAMS = `?${queryString.stringify({ page: 1, perPage: 1000 })}&sort=partyRole&sortDirection=asc`;
const MEDIATION_PARAMS = `?${queryString.stringify({ page: 1, perPage: 1000 })}`;

/* ─── Component ──────────────────────────────────────────────────────────── */

export default function CaseDetails({ id }) {
  const [state, setState] = useState();
  const [breadcrumbs, setBreadcrumbs] = useState(["Cases"]);
  const [caseDetails, setCaseDetails] = useState({});
  const [caesLifeCycle, setCaseLifeCyle] = useState([]);
  const [isRespondent, setIsRespondent] = useState(false);
  const [ownerId, setOwnerId] = useState();
  const [respondentId, setRespondentId] = useState();
  const [negotiationRounds, setNegotiationRounds] = useState({});
  const [currentState, setCurrentState] = useState({});
  const [openPaymentBox, setOpenPaymentBox] = useState(false);
  const [pendingRegistrationFee, setPendingRegistrationFee] = useState(false);
  const [openAssignCaseManager, setOpenAssignCaseManager] = useState(false);
  const [refreshDetails, setRefreshDetails] = useState(true);
  const [comments, setComments] = useState([]);
  const [dialogData, setDialogData] = useState({});
  const [open, setOpen] = useState(false);
  const [partyList, setPartyList] = useState([]);
  const [settingsModal, setSettingsModal] = useState(false);
  const [meetingDetail, setMeetingDetail] = useState();
  const [transcriptControl, settranscriptControl] = useState();
  const [refreshStatus, setRefreshStatus] = useState(true);
  const [statusModal, setStatusModal] = useState(false);
  const [docUploadModal, setDocUploadModal] = useState();
  const [fields, setFields] = useState(false);
  const [streamModal, setStreamModal] = useState(false);
  const [streamData, setStreamData] = useState("");
  const [publicModal, setPublicModal] = useState(false);
  const [requestedSmartOdrAction, setRequestedSmartOdrAction] = useState(null);
  const [tab, setTab] = useState(() => {
    const path = typeof window !== "undefined" ? window.location.pathname : "";
    if (path.includes("/core-bundle") || path.includes("/trail-bundle")) {
      return { key: "documents", label: "Documents" };
    }
    return { key: "sheet", label: "Case Sheet" };
  });
  const [view, setView] = useState(() => {
    const path = typeof window !== "undefined" ? window.location.pathname : "";
    if (path.includes("/core-bundle") || path.includes("/trail-bundle")) {
      return "coreBundle";
    }
    return false;
  });

  const MTRef = useRef();
  const { setLoader, activeDoc, setActiveDoc } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const { triggerNotify, setTriggerNotify } = useNotification();

  const PORTAL_NAME = "Cm";
  const {
    getStageConfig,
    getLifecycleForResolution,
    ensureLoaded,
    loaded: stagesLoaded,
    stages: allStages,
  } = useLifecycleStages(PORTAL_NAME);

  const stageConfig = getStageConfig(currentState?.key, caseDetails);
  const isActionsDisabled = !!stageConfig.actionsDisabled;
  const isQuitState = !!stageConfig.isQuitState;

  useEffect(() => {
    const handleLocationSync = () => {
      const path =
        typeof window !== "undefined" ? window.location.pathname : "";
      if (path.includes("/core-bundle") || path.includes("/trail-bundle")) {
        setTab((prev) =>
          prev.key !== "documents"
            ? { key: "documents", label: "Documents" }
            : prev,
        );
      } else if (
        id &&
        (path.endsWith(`/arbitration/${id}`) ||
          path.endsWith(`/mediation/${id}`) ||
          path.endsWith(`/negotiation/${id}`))
      ) {
        setTab((prev) =>
          prev.key !== "sheet" ? { key: "sheet", label: "Case Sheet" } : prev,
        );
      }
    };

    window.addEventListener("popstate", handleLocationSync);
    return () => window.removeEventListener("popstate", handleLocationSync);
  }, [id]);

  /* ── Helpers ── */

  const showError = useCallback(
    (error) => enqueueSnackbar(getErrorMessage(error), { variant: "error" }),
    [enqueueSnackbar],
  );

  const showSuccess = useCallback(
    (message) => enqueueSnackbar(message, { variant: "success" }),
    [enqueueSnackbar],
  );

  const closeDialog = useCallback(() => setOpen(false), []);

  const parseSmartOdr = (value) => {
    const raw = value?.reportDataToODR ?? value?.reportDatatoODR;
    if (!raw) return null;
    if (typeof raw === "string") {
      try {
        return JSON.parse(raw);
      } catch (_error) {
        return null;
      }
    }
    return raw;
  };

  const hasSmartOdrPending = useCallback(() => {
    if (caseDetails?.resolutionKind === "arbitration") {
      return false;
    }
    const smartOdrData = parseSmartOdr(caseDetails);
    return !!caseDetails?.smartODRDisputeId && smartOdrData?.isTrigger !== true;
  }, [caseDetails]);

  const openDialog = useCallback((data) => {
    setDialogData(data);
    setOpen(true);
  }, []);

  const descriptionTextStyle = {
    textAlign: "left",
    fontFamily: theme.fonts.primaryFontSemiBold,
  };

  const getDialogConfig = useCallback(
    (type) => {
      const isNegotiation = caseDetails?.resolutionKind === "negotiation";
      const kind = _.capitalize(caseDetails?.resolutionKind);

      const configs = {
        MEDIATION_SUCCESS: {
          primaryBtnText: "Cancel",
          secondaryBtnText: "Proceed",
          clickSecondarybtn: callMediationSucess,
          desc: `Congratulations, your ${caseDetails?.resolutionKind} has been a success. Are you sure you want to proceed?`,
          heading: `${kind} Success`,
          buttonType: type,
        },
        QUIT: {
          primaryBtnText: "Cancel",
          secondaryBtnText: "Close",
          clickSecondarybtn: (reasonText, dateOfClose, closeType) =>
            isNegotiation
              ? callQuitNegotiationCase(reasonText, dateOfClose, closeType)
              : callQuitCase(reasonText, dateOfClose, closeType),
          desc: `Please note once you close the case, you cannot continue your ${caseDetails?.resolutionKind}.`,
          heading: "Do you really want to Close your case?",
          buttonType: type,
          status: true,
        },
        REOPEN_CASE: {
          primaryBtnText: "Cancel",
          secondaryBtnText: "Proceed",
          clickSecondarybtn: callReopenCase,
          desc: "Click proceed to Reopen your case, Click cancel to Cancel your action",
          heading: "Do you really want to Reopen your case?",
          buttonType: type,
        },
      };

      return configs[type];
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // eslint-disable-next-line react-hooks/exhaustive-deps
      caseDetails?.resolutionKind,
      callMediationSucess,
      callQuitCase,
      callQuitNegotiationCase,
      callReopenCase,
    ],
  );

  /* ── Notification refresh ── */

  useEffect(() => {
    if (triggerNotify) {
      setRefreshDetails(true);
      setTriggerNotify(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerNotify]);

  /* ── Meeting / transcription access ── */

  useEffect(() => {
    if (!id || !refreshStatus) return;

    async function fetchMeetingAccess() {
      try {
        const data = await CaseService.GetMeetingAccesscases(id);
        setMeetingDetail(data);
        settranscriptControl(data);
      } catch (error) {
        showError(error);
      }
    }

    fetchMeetingAccess();
    setRefreshStatus(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshStatus]);

  /* ── Case data fetch ── */

  useEffect(() => {
    if (!id || !refreshDetails) return;

    async function fetchPartyList() {
      try {
        const res = await CaseService.getPartyListByCaseId(id, PARTY_PARAMS);
        if (res?.data) setPartyList(res.data);
      } catch (error) {
        showError(error);
      }
    }

    async function fetchMediations() {
      setLoader({ state: true, message: "Fetching case details..." });
      try {
        const res = await CaseService.mediations(id, MEDIATION_PARAMS);
        if (res) setComments(res.data);
      } catch (error) {
        showError(error);
      } finally {
        setLoader({ state: false });
      }
    }

    async function fetchNegotiations() {
      setLoader({ state: true, message: "Fetching case details..." });
      try {
        const res = await CaseService.negotiations(id);
        setNegotiationRounds(res);
      } catch (error) {
        showError(error);
      } finally {
        setLoader({ state: false });
      }
    }

    async function fetchCase() {
      setActiveDoc(null);
      setLoader({ state: true, message: "Fetching case details..." });
      try {
        const res = await CaseService.getCase(id);
        if (!res) return;

        const caseRes = { ...res };

        if (caseRes.status !== "draft") {
          if (caseRes.status === "pendingRegistrationFee") {
            setPendingRegistrationFee(true);
          }
          if (!caseRes.respondentPartyId) {
            // status stays as-is
          } else if (
            caseRes.respondentStatus === "pending" ||
            caseRes.respondentStatus === "declined"
          ) {
            caseRes.status = RESPONDANT_ONBOARDED;
          } else if (
            caseRes.status === NEGOTIATION_REACHED &&
            caseRes.subscriptionKind === "adhoc"
          ) {
            caseRes.status = BOTH_PAID_NEGOTIATION;
          }
        }

        if (caseRes.resolutionKind === "negotiation") {
          fetchNegotiations();
        } else {
          fetchMediations();
        }

        fetchPartyList();
        const parsedSmartOdr = parseSmartOdr(caseRes);
        if (parsedSmartOdr) {
          caseRes.reportDataToODR = parsedSmartOdr;
        }
        setCaseDetails(caseRes);
        setBreadcrumbs([
          "Cases",
          _.startCase(caseRes.resolutionKind),
          caseRes.title,
          _.startCase(tab.label),
        ]);
        const stageRows = await ensureLoaded();
        const kind = (caseRes?.resolutionKind || "").toLowerCase();
        const lifecycle = getLifecycleForResolution(kind, stageRows);
        setCaseLifeCyle((prev) => {
          const prevKeys = (prev || []).map((s) => s.key).join(",");
          const nextKeys = lifecycle.map((s) => s.key).join(",");
          if (prevKeys === nextKeys) return prev;
          return lifecycle;
        });

        setIsRespondent(caseRes.agentRole !== CLAIMENT_STR);
        setOwnerId(caseRes.claimantPartyId);
        setRespondentId(caseRes.respondentPartyId);
      } catch (error) {
        showError(error);
        navigate("/dashboard/case-manager/negotiation");
      } finally {
        setLoader({ state: false });
        window.scrollTo(0, 0);
      }
    }

    fetchCase();
    setRefreshDetails(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshDetails]);

  useEffect(() => {
    setBreadcrumbs([
      "Cases",
      _.startCase(caseDetails.resolutionKind),
      caseDetails.title,
      _.startCase(tab.label),
    ]); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  useEffect(() => {
    if (!stagesLoaded || !caseDetails?.resolutionKind) return;
    if (!allStages || !allStages.length) return;

    const kind = String(caseDetails.resolutionKind).toLowerCase();
    const lifecycle = getLifecycleForResolution(kind, allStages);
    if (!lifecycle.length) return;

    setCaseLifeCyle((prev) => {
      const prevKeys = (prev || []).map((s) => s.key).join(",");
      const nextKeys = lifecycle.map((s) => s.key).join(",");
      if (prevKeys === nextKeys) return prev;
      return lifecycle;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stagesLoaded, caseDetails?.resolutionKind, allStages?.length]);


  useEffect(() => {
    if (!caesLifeCycle.length || _.isEmpty(caseDetails)) return;

    let next = null;

    if (caesLifeCycle.some((el) => el.key === caseDetails.status)) {
      const base = caesLifeCycle.find((el) => el.key === caseDetails.status);
      const cfg = getStageConfig(caseDetails.status, caseDetails);
      next = {
        ...base,
        text: cfg.text || base?.text || base?.label,
        cta: cfg.ctas || base?.cta || [],
      };
    } else if (caseDetails.status === "finalAward") {
      const cfg = getStageConfig("finalAward", caseDetails);
      next = {
        label: cfg.text || "Final Award",
        key: "finalAward",
        index: cfg.phaseIndex ?? cfg.index ?? 5,
        enableSelection: !!cfg.enableSelection,
        text: cfg.text || cfg.label || "Final Award",
        cta: cfg.ctas || [],
      };
    } else if (!isRespondent) {
      if (caseDetails.respondentId) {
        next = caesLifeCycle.find((el) => el.index === 2) || null;
      } else {
        next = caesLifeCycle.find((el) => el.index === 1) || null;
      }
    }

    if (!next) return;

    setCurrentState((prev) => {
      if (prev?.key === next.key && prev?.index === next.index) return prev;
      return next;
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [
    caesLifeCycle, // eslint-disable-next-line react-hooks/exhaustive-deps
    caseDetails?.status, // eslint-disable-next-line react-hooks/exhaustive-deps
    caseDetails?.respondentId,
    isRespondent,
  ]); 

  /* ── Navigation ── */

  const onBreadcrumbClick = useCallback(
    (selected) => {
      const key = _.snakeCase(selected);
      if (key === _.snakeCase(caseDetails?.resolutionKind) || key === "cases") {
        navigate(`/dashboard/case-manager/${caseDetails?.resolutionKind}`);
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [caseDetails?.resolutionKind],
  );

  /* ── Async actions ── */

  async function callMediationSucess() {
    if (hasSmartOdrPending()) {
      enqueueSnackbar(
        "Please trigger Smart ODR before closing or marking this case as success.",
        { variant: "error" },
      );
      closeDialog();
      return;
    }

    setLoader({ state: true, message: "Updating case details..." });
    try {
      const res = await CaseService.mediationSuccess(id);
      if (res?.message) showSuccess(res.message);
    } catch (error) {
      showError(error);
    } finally {
      closeDialog();
      setLoader({ state: false });
      setRefreshDetails(true);
    }
  }

  async function callQuitCase(reasonText, dateOfClose, type = "close") {
    if (hasSmartOdrPending()) {
      enqueueSnackbar(
        "Please trigger Smart ODR before closing or marking this case as success.",
        { variant: "error" },
      );
      closeDialog();
      return;
    }

    setLoader({ state: true, message: "Updating case details..." });
    try {
      const payload = {
        reasonForQuit: reasonText ?? caseDetails?.reasonForClose ?? undefined,
        dateOfClose: dateOfClose ?? caseDetails?.dateofClose ?? undefined,
      };
      if (type === "casewithdrawn") {
        payload.Type = "casewithdrawn";
      }
      const res = await CaseService.quitMediation(id, payload);
      if (res?.message) {
        showSuccess(res.message);
        navigate(`/dashboard/case-manager/${caseDetails?.resolutionKind}`);
      }
    } catch (error) {
      showError(error);
    } finally {
      closeDialog();
      setLoader({ state: false });
    }
  }

  async function callQuitNegotiationCase(
    reasonText,
    dateOfClose,
    type = "close",
  ) {
    if (hasSmartOdrPending()) {
      enqueueSnackbar(
        "Please trigger Smart ODR before closing or marking this case as success.",
        { variant: "error" },
      );
      closeDialog();
      return;
    }

    setLoader({ state: true, message: "Updating case details..." });
    try {
      const payload = {
        reasonForQuit: reasonText ?? caseDetails?.reasonForClose ?? undefined,
        dateOfClose: dateOfClose ?? caseDetails?.dateofClose ?? undefined,
      };
      if (type === "casewithdrawn") {
        payload.Type = "casewithdrawn";
      }
      const res = await CaseService.quitNegotiation(id, payload);
      if (res?.message) {
        showSuccess(res.message);
        navigate(`/dashboard/case-manager/${caseDetails?.resolutionKind}`);
      }
    } catch (error) {
      showError(error);
    } finally {
      closeDialog();
      setLoader({ state: false });
    }
  }

  const handleSmartOdrActionContinue = useCallback(
    async (action) => {
      try {
        const config = getDialogConfig(action);
        if (config) {
          openDialog({
            ...config,
            clickPrimaryBtn: closeDialog,
            onDialogClose: closeDialog,
            descriptionTextStyle,
          });
        }
      } finally {
        setRequestedSmartOdrAction(null);
      }
    },
    [getDialogConfig, openDialog, closeDialog, descriptionTextStyle],
  );

  async function callReopenCase() {
    setLoader({ state: true, message: "Updating case details..." });
    try {
      const res = await CaseService.updateCaseReopen(id);
      if (res?.message) showSuccess(res.message);
    } catch (error) {
      showError(error);
    } finally {
      closeDialog();
      setLoader({ state: false });
      setRefreshDetails(true);
    }
  }

  async function callRemoveMediator(mediator, caseDetails) {
    setLoader({ state: true, message: "Removing mediator..." });
    const payload = {
      requestedMediators: caseDetails?.requestedMediators?.filter(
        (el) => el?.id !== mediator?.id,
      ),
    };
    try {
      const res = await CaseService.updateCase(id, payload);
      if (res?.message) showSuccess(res.message);
    } catch (error) {
      showError(error);
    } finally {
      closeDialog();
      setLoader({ state: false });
      setRefreshDetails(true);
    }
  }

  async function presidingArbitrator(mediator) {
    const payload = {
      presidingArbitrator:
        mediator?.presidingArbitrator === "no" || !mediator?.presidingArbitrator
          ? "yes"
          : "no",
    };
    try {
      const res = await CaseService.presidingArbitrator(
        id,
        mediator?.id,
        payload,
      );
      if (res?.message) showSuccess(res.message);
    } catch (error) {
      showError(error);
    } finally {
      setRefreshDetails(true);
    }
  }

  async function getMeetingjoin(id) {
    try {
      const url = await CaseService.getMeeting(id);
      window.open(url);
    } catch (error) {
      showError(error);
    } finally {
      closeDialog();
    }
  }

  async function stopTranscription(id) {
    setLoader({ state: true, message: "Update Meeting Status..." });
    try {
      const res = await CaseService.stopTranscription(id);
      if (res?.message) showSuccess(res.message);
      setRefreshStatus(true);
    } catch (error) {
      showError(error);
    } finally {
      closeDialog();
      setLoader({ state: false });
    }
  }

  async function startTranscription(id) {
    setLoader({ state: true, message: "Start transcription..." });
    try {
      const res = await CaseService.startTranscription(id);
      if (res?.message) showSuccess(res.message);
      setTimeout(() => setRefreshStatus(true), 5000);
    } catch (error) {
      showError(error);
    } finally {
      setLoader({ state: false });
      setStreamModal(false);
    }
  }

  async function pushCaseToArbitration(id) {
    try {
      const res = await CaseService.pushCaseToArbitration(id);
      if (res?.message) showSuccess(res.message);
    } catch (error) {
      showError(error);
    } finally {
      closeDialog();
    }
  }

  async function generateRTMPLink(meetingId) {
    setLoader({ state: true, message: "fetching rtmp..." });
    try {
      const res = await CaseService.generateRTMPLink(meetingId);
      if (res?.message) showSuccess(res.message);
      setStreamData(res);
    } catch (error) {
      showError(error);
    } finally {
      closeDialog();
      setLoader({ state: false });
      setStreamModal(true);
    }
  }

  /* ── Dialog builders ── */

  const onbuttonClick = useCallback(
    (type) => {
      const hasSmartOdrCase = !!caseDetails?.smartODRDisputeId;
      const isArbitration = caseDetails?.resolutionKind === "arbitration";

      if (
        (type === "MEDIATION_SUCCESS" || type === "QUIT") &&
        hasSmartOdrCase &&
        !isArbitration
      ) {
        setRequestedSmartOdrAction(type);
        return;
      }

      const config = getDialogConfig(type);
      if (!config) return;

      openDialog({
        ...config,
        clickPrimaryBtn: closeDialog,
        onDialogClose: closeDialog,
        descriptionTextStyle,
      });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // eslint-disable-next-line react-hooks/exhaustive-deps
      caseDetails?.resolutionKind, // eslint-disable-next-line react-hooks/exhaustive-deps
      getDialogConfig, 
      openDialog,
      closeDialog,
      descriptionTextStyle,
    ],
  );

  const removeMediator = useCallback(
    (mediator, caseDetails) => {
      const isMediation = caseDetails?.resolutionKind === "mediation";
      openDialog({
        primaryBtnText: "No",
        secondaryBtnText: "Yes",
        clickSecondarybtn: () => callRemoveMediator(mediator, caseDetails),
        clickPrimaryBtn: closeDialog,
        onDialogClose: closeDialog,
        desc: `Are you sure you want to remove this ${isMediation ? "mediator" : "arbitrator"}?`,
        heading: `Remove ${isMediation ? "Mediator" : "Arbitrator"}`,
        descriptionTextStyle,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [caseDetails?.resolutionKind],
  );

  const stopTranscriptionAlert = useCallback(
    (id) => {
      openDialog({
        primaryBtnText: "No",
        secondaryBtnText: "Yes",
        clickSecondarybtn: () => stopTranscription(id),
        clickPrimaryBtn: closeDialog,
        onDialogClose: closeDialog,
        desc: (
          <>
            After you have stopped this live transcription session your
            transcript will be moved to the case documents section. Please
            ensure you have saved your transcription changes.
            <br />
            <br />
            <b style={{ fontSize: "18px" }}>
              Are you sure you want to stop the transcription
            </b>
            ?
          </>
        ),
        heading: "Stop Transcription",
        descriptionTextStyle,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const joinMeetingAlert = useCallback(
    (id, resolutionKind) => {
      openDialog({
        primaryBtnText: "Proceed",
        secondaryBtnText: "Cancel",
        clickSecondarybtn: closeDialog,
        clickPrimaryBtn: () => getMeetingjoin(id),
        onDialogClose: closeDialog,
        desc: (
          <b style={{ color: COLORS.LOGOUT_RED }}>
            We may record the meeting for case proceedings and transcription
            purposes
          </b>
        ),
        heading: `Join ${_.capitalize(resolutionKind)} Session`,
        descriptionTextStyle,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const pushCaseToArbitrationAlert = useCallback(
    (id) => {
      openDialog({
        primaryBtnText: "Proceed",
        secondaryBtnText: "Cancel",
        clickSecondarybtn: closeDialog,
        clickPrimaryBtn: () => pushCaseToArbitration(id),
        onDialogClose: closeDialog,
        desc: <b>Are you sure you want to move case to arbitration?</b>,
        heading: "Move to Arbitration",
        descriptionTextStyle,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  /* ── Derived values ── */

  const isNonNegotiation = caseDetails?.resolutionKind !== "negotiation";
  const isMediation = caseDetails?.resolutionKind === "mediation";
  const isNotDraft = caseDetails?.status !== "draft";
  const mediatorTitle =
    caseDetails?.resolutionKind === "mediation" ? "Mediator" : "Arbitrator";
  const meetingOpen =
    meetingDetail?.recordingStatus === "yes" &&
    meetingDetail?.transcriptionStatus === "yes" &&
    meetingDetail?.status === "open";

  /* ── Render ── */

  return (
    <Fragment>
      {activeDoc ? null : (
        <ActionBar
          breadcrumbs={breadcrumbs}
          onBreadcrumbClick={onBreadcrumbClick}
        />
      )}

      <PageWrapper>
        {/* Case Details Card */}
        <CaseDetailsCard
          isActionsDisabled={isActionsDisabled}
          disableRefund={
            pendingRegistrationFee || caseDetails?.status === "draft"
          }
          setOpenPaymentBox={setOpenPaymentBox}
          caseDetails={caseDetails}
          refreshDetails={refreshDetails}
          setRefreshDetails={setRefreshDetails}
          pendingRegistrationFee={pendingRegistrationFee}
          requestedSmartOdrAction={requestedSmartOdrAction}
          setRequestedSmartOdrAction={setRequestedSmartOdrAction}
          onSmartOdrActionContinue={handleSmartOdrActionContinue}
          {...{
            setState,
            state,
            id,
            MTRef,
            partyList,
            docUploadModal,
            setDocUploadModal,
            setFields,
            setStatusModal,
            tab,
            setTab,
            view,
            setView,
            isActionsDisabled,
            isNonNegotiation,
            isNotDraft,
            mediatorTitle,
            meetingOpen,
            setSettingsModal,
            setPublicModal,
            transcriptControl,
            settranscriptControl,
            setRefreshDetails,
            meetingDetail,
            stopTranscriptionAlert,
            pushCaseToArbitrationAlert,
            startTranscription,
            setRefreshStatus,
            generateRTMPLink,
            joinMeetingAlert,
            activeDoc,
            setActiveDoc,
            currentState
          }}
          items={caesLifeCycle}
          resolutionKind={caseDetails?.resolutionKind}
          selectedIndex={currentState?.index}
          isMediation={isMediation}
          status={currentState?.text}
          currentStateKey={currentState?.key}
          removeMediator={removeMediator}
          presidingArbitrator={presidingArbitrator}
          addMediator={() => setOpenAssignCaseManager(true)}
        />

        <>
          {isNonNegotiation && tab.key === "sheet" && (
            <CardSlot>
              <CopytoClipboard id={id} />
            </CardSlot>
          )}

          {isNotDraft && tab.key === "sheet" && (
            <>
              <Section>
                {caseDetails?.resolutionKind === "negotiation" ? (
                  <NegotiationState
                    {...{
                      currentState,
                      negotiationRounds,
                      isRespondent,
                      ownerId,
                      respondentId,
                      caseDetails,
                    }}
                  />
                ) : (
                  <MediationState
                    {...{
                      currentState,
                      negotiationRounds,
                      isRespondent,
                      ownerId,
                      respondentId,
                      caseDetails,
                      comments,
                      setComments,
                      partyList,
                    }}
                    isLocalTranscriptionServer={
                      meetingDetail?.isLocalTranscriptionServer
                    }
                  />
                )}
              </Section>

              {(isQuitState || caseDetails?.reasonForClose) &&
                tab.key === "sheet" && (
                  <QuitWrapper>
                    <QuitCard>
                      <QuitLabel>Reason for Closing</QuitLabel>
                      <QuitValue>
                        {caseDetails?.reasonForClose || "-"}
                      </QuitValue>
                    </QuitCard>

                    <QuitCard>
                      <QuitLabel>Date of Close</QuitLabel>
                      <QuitValue>{caseDetails?.dateofClose || "-"}</QuitValue>
                    </QuitCard>
                  </QuitWrapper>
                )}

              {tab.key === "sheet" && (
                <Section>
                  <CaseCTA
                    cta={
                      stageConfig.ctas ||
                      (isNonNegotiation
                        ? currentState?.cta
                        : currentState?.cta?.filter(
                            (c) => c.type !== "MEDIATION_SUCCESS",
                          )) ||
                      []
                    }
                    resolutionKind={caseDetails?.resolutionKind}
                    disableButton={false}
                    onbuttonClick={onbuttonClick}
                  />
                </Section>
              )}
            </>
          )}
        </>
      </PageWrapper>

      {/* Modals & Drawers — unchanged */}
      <AlertDialog
        isOpen={open}
        {...dialogData}
        descriptionTextStyle={descriptionTextStyle}
        isSmartODR={
          caseDetails?.resolutionKind === "mediation" &&
          !!caseDetails?.smartODRDisputeId
        }
      />

      <DrawerTable
        {...{ state, setState, id, MTRef, docUploadModal, caseDetails }}
        title={caseDetails?.title}
        type={caseDetails?.resolutionKind}
        claimantId={caseDetails?.claimantParty?.ownerId}
        respondentId={caseDetails?.respondentParty?.ownerId}
        agreementsAndAwards={caseDetails?.agreementsAndAwards}
        isActionsDisabled={isActionsDisabled}
      />

      <ExtraFieldsDrawer {...{ fields, setFields, caseDetails, id }} />

      {pendingRegistrationFee && (
        <PaymentModal
          modal={openPaymentBox}
          setModal={() => {
            setOpenPaymentBox(false);
            setRefreshDetails(true);
          }}
          id={caseDetails?.id}
        />
      )}

      <AssignCaseMediator
        modal={openAssignCaseManager}
        setModal={setOpenAssignCaseManager}
        type={mediatorTitle}
        onAssignSuccess={() => {
          setRefreshDetails(true);
          setOpenAssignCaseManager(false);
        }}
        caseDetails={caseDetails}
      />

      <TranscriptionSettings
        modal={settingsModal}
        setModal={setSettingsModal}
        {...{ setRefreshStatus, meetingDetail, setMeetingDetail, id }}
      />

      <CaseDetailsStatus
        currentState={currentState}
        {...{ statusModal, setStatusModal, setRefreshDetails, id, caseDetails }}
      />

      {streamModal && (
        <RTMP
          {...{ streamModal, setStreamModal, streamData, id }}
          handleStart={startTranscription}
        />
      )}

      {publicModal && (
        <GenerateGlobalMeeting
          {...{ publicModal, setPublicModal, id }}
          resolutionKind={caseDetails?.resolutionKind}
          title={caseDetails?.title}
        />
      )}
    </Fragment>
  );
}

/* ─── Styled Components (unchanged) ─────────────────────────────────────── */

export const ControlsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ControlsGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const CardSlot = styled.div`
  margin-right: 25px;
  margin-top: 28px;
`;

export const LinkSlot = styled.div`
  margin-right: 25px;
  margin-top: 32px;
`;

export const Section = styled.div`
  margin-top: 28px;
`;

export const ReasonForQuit = styled.div`
  font-family: ${theme.fonts.primaryFontBold};
  font-size: 16px;
  color: ${COLORS.LOGOUT_RED};
`;

export const ReasonForQuitText = styled.p`
  font-family: ${theme.fonts.primaryFontBold};
  font-size: 16px;
  color: ${COLORS.COLOR_DARK};
  margin-left: 4px;
`;

export const QuitContainer = styled.div`
  background-color: ${COLORS.PRIMARY_WHITE};
  border: 1px solid ${COLORS.COLOR_DARK};
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  margin-top: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease-in-out;
  max-width: 100%;

  &:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
  }

  @media (max-width: 480px) {
    padding: 18px;
    border-radius: 14px;
  }

  @media (min-width: 768px) {
    max-width: 85%;
  }
`;

export const QuitContents = styled.div`
  font-size: 16px;
  line-height: 1.5;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontSemiBold};
  word-break: break-word;

  strong,
  b {
    font-family: ${theme.fonts.primaryFontExtraBold};
    color: inherit;
  }

  @media (max-width: 480px) {
    font-size: 15.5px;
  }
`;

export const QuitWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 24px;

  @media ${theme.breakpoints.sm_up} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const QuitCard = styled.div`
  padding: 16px 18px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  }
`;

export const QuitLabel = styled.div`
  font-size: 13px;
  color: ${COLORS.LOGOUT_RED};
  margin-bottom: 6px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const QuitValue = styled.div`
  font-size: 15px;
  color: ${COLORS.COLOR_DARK};
  font-family: ${theme.fonts.primaryFontSemiBold};
  line-height: 1.5;
  word-break: break-word;

  & strong {
    font-family: ${theme.fonts.primaryFontExtraBold};
  }
`;
